@let isLoggedIn = utenteService.isLoggato | async;

@if (isLoggedIn) {
  <mat-toolbar color="primary" class="sticky-toolbar">
    <button class="menu-button" mat-icon-button (click)="toggleSidenav()" aria-label="Apri il menu di navigazione"><mat-icon>menu</mat-icon></button>
    @if (showAppName) {
      <h1>{{applicationService.getApplicationName(true)}}</h1>
    }
    @if (showAppLogo) {
      <ev-logo [big]="false"></ev-logo>
    }
    <span class="toolbar-context">Area personale</span>
    <div class="toolbar-spacer"></div>
    @if (currentToolbarAction) {
      @if (currentToolbarAction.type === 'button') {
        <button class="toolbar-action" (click)="toolbarActionClick(currentToolbarAction)"
          mat-raised-button [attr.aria-label]="currentToolbarAction.text">
          {{currentToolbarAction.text}}
        </button>
      }
    }
    @if (toolbarService._showLogout | async) {
      <a class="toolbar-account" mat-raised-button color="primary" routerLink="/logout">
        <mat-icon>logout</mat-icon>
        Cambia utente
      </a>
    }
    @if (showHomeShortcut) {
      <button mat-icon-button type="button" class="notifiche-button toolbar-home-button" aria-label="Torna alla home"
        (click)="router.navigate(['/homepage'])">
        <mat-icon>home</mat-icon>
      </button>
    }
    @let richiesteNonLette = richiesteNonLette$ | async;
    <button mat-icon-button type="button" class="notifiche-button" [matBadge]="richiesteNonLette"
      [matBadgeHidden]="!richiesteNonLette" matBadgeColor="warn" aria-label="Apri le richieste"
      (click)="router.navigate(['/comunicazioni/richieste'])">
      <mat-icon [class.blink-alert]="richiesteNonLette">article</mat-icon>
    </button>
    @let avvisiNonLetti = avvisiNonLetti$ | async;
    <button mat-icon-button type="button" class="notifiche-button" [matBadge]="avvisiNonLetti"
      [matBadgeHidden]="!avvisiNonLetti" matBadgeColor="warn" aria-label="Apri gli avvisi"
      (click)="router.navigate(['/comunicazioni/avvisi'])">
      <mat-icon [class.blink-alert]="avvisiNonLetti">{{ avvisiNonLetti ? 'notifications_active' : 'notifications' }}</mat-icon>
    </button>
  </mat-toolbar>
}

<mat-sidenav-container [class.sidenav]="isLoggedIn">
  @if (isLoggedIn) {
    <mat-sidenav class="app-sidenav" mode="over" #snav>
      <mat-nav-list (click)="snav.close()">
        <div class="sidenav-profile"><ev-user-profile></ev-user-profile></div>
        <mat-divider></mat-divider>
        <p class="nav-section-label">PRINCIPALE</p>
        <a mat-list-item routerLink="/homepage" routerLinkActive="nav-item-active" [routerLinkActiveOptions]="{ exact: true }">
          <div class="list-item-with-icon">
            <mat-icon>home</mat-icon>
            Home
          </div>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item routerLink="/orariAmbulatorio" routerLinkActive="nav-item-active">
          <div class="list-item-with-icon">
            <mat-icon>schedule</mat-icon>
            Orari ambulatorio
          </div>
        </a>
        <a mat-list-item routerLink="/bachecaMedico" routerLinkActive="nav-item-active">
          <div class="list-item-with-icon">
            <mat-icon>content_paste</mat-icon>
            Bacheca medico
          </div>
        </a>
        <a mat-list-item routerLink="/farmacie" routerLinkActive="nav-item-active">
          <div class="list-item-with-icon">
            <mat-icon>medication</mat-icon>
            Email Farmacie
          </div>
        </a>
        <mat-divider></mat-divider>
        <p class="nav-section-label">ACCOUNT</p>
        @if (isPagamentiVisibile) {
          <a mat-list-item routerLink="/impostazioni/dati-fatturazione/abbonamento-in-scadenza" routerLinkActive="nav-item-active"
            >
            <div class="list-item-with-icon">
              <mat-icon>card_membership</mat-icon>
              Pagamenti
            </div>
          </a>
        }
        <a mat-list-item routerLink="/news" routerLinkActive="nav-item-active">
          <div class="list-item-with-icon">
            <mat-icon>priority_high</mat-icon>
            Novita!
          </div>
        </a>
        <a mat-list-item (click)="documentsService.downloadPrivacyDoc()">
          <div class="list-item-with-icon">
            <mat-icon>lock</mat-icon>
            Documento privacy
          </div>
        </a>
        <mat-divider></mat-divider>
        <p class="nav-section-label">SUPPORTO E DOCUMENTI</p>
        <a mat-list-item (click)="documentsService.downloadFAQDoc()">
          <div class="list-item-with-icon">
            <mat-icon>quiz</mat-icon>
            FAQ
          </div>
        </a>
        <a mat-list-item (click)="documentsService.downloadManualDoc()">
          <div class="list-item-with-icon">
            <mat-icon>description</mat-icon>
            Manuale
          </div>
        </a>
        <a mat-list-item [href]="URL_YT_NEXTCOMUNICA" target="_blank">
          <div class="list-item-with-icon">
            <mat-icon>videocam</mat-icon>
            Canale YouTube
          </div>
        </a>
        <a mat-list-item (click)="applicationService.richiediAssistenzaInterno()">
          <div class="list-item-with-icon">
            <mat-icon>contact_support</mat-icon>
            Richiedi assistenza
          </div>
        </a>
        <a mat-list-item routerLink="/cambioPassword" routerLinkActive="nav-item-active">
          <div class="list-item-with-icon">
            <mat-icon>sync_lock</mat-icon>
            Cambio password
          </div>
        </a>
        <a mat-list-item routerLink="/impostazioni" routerLinkActive="nav-item-active">
          <div class="list-item-with-icon">
            <mat-icon>settings</mat-icon>
            Impostazioni
          </div>
        </a>
        <mat-divider></mat-divider>
        <p class="nav-section-label">SESSIONE</p>
        <a mat-list-item class="nav-logout" routerLink="/logout" routerLinkActive="nav-item-active">
          <div class="list-item-with-icon">
            <mat-icon>logout</mat-icon>
            Esci
          </div>
        </a>
        <mat-divider></mat-divider>
        <mat-list-item (click)="router.navigate(['debug'])">
          <span style="font-size: 12px;">
            © {{currentYear}} {{applicationService.getApplicationName()}}
          </span>
        </mat-list-item>
        <a mat-list-item href="javascript:void(0)" target="_blank" [routerLink]="['/iprivacy']">
          <span style="font-size: 12px;">
            Trattamento dei dati <br /> personali
          </span>
        </a>
        @if (!applicationService.isNextComunica()) {
          <a mat-list-item href="javascript:void(0)" target="_blank"
            [routerLink]="['/isicurezza']">
            <span style="font-size: 12px;">
              Termini e condizioni
            </span>
          </a>
        }
        @if (applicationService.isNextComunica()) {
          <a mat-list-item href="assets/documents/termini-nc.pdf"
            target="_blank">
            <span style="font-size: 12px;">
              Termini e condizioni
            </span>
          </a>
        }
        <a mat-list-item href="javascript:void(0)" target="_blank" [routerLink]="['/icookie']">
          <span style="font-size: 12px;">
            Informativa cookie
          </span>
        </a>
      </mat-nav-list>
    </mat-sidenav>
  }
  <mat-sidenav-content [class.sidenav-content]="isLoggedIn">
    <div [class.main-container]="isLoggedIn">
      <router-outlet></router-outlet>
    </div>
    @if (isLoggedIn && (displayService.isSmall | async)) {
      <ev-button-toggle [buttons]="buttons"></ev-button-toggle>
    }
  </mat-sidenav-content>
</mat-sidenav-container>


@if (isLoggedIn) {
  <app-news-accesso></app-news-accesso>
}
